import { useBreakpointValue } from "@gemini/core";
import { useEffect, useState } from "react";
export function useIsDesktopOrMobile() {
    const breakpoint = useBreakpointValue({ base: "mobile", lg: "desktop" });
    const [userDevice, setUserDevice] = useState();
    const [isDesktopCSR, setIsDesktopCSR] = useState(false);
    const [isMobileCSR, setIsMobileCSR] = useState(false);
    useEffect(() => {
        // Avoid setting state during SSR
        if (!breakpoint)
            return;
        setUserDevice(breakpoint);
        setIsDesktopCSR(breakpoint === "desktop");
        setIsMobileCSR(breakpoint === "mobile");
    }, [breakpoint]);
    return { userDevice, isDesktopCSR, isMobileCSR };
}
